import { createSlice } from '@reduxjs/toolkit';
import { ENUM_SCHEDULER_STATUS } from '../../enums/enums';

const schedulerSlice = createSlice({
  name: 'scheduler',
  initialState: {
    mailingsFilter: [ENUM_SCHEDULER_STATUS.active,ENUM_SCHEDULER_STATUS.progress],
    mailings: []
  },
  reducers: {
    setMailingsFilter: (state, action) => {
      state.mailingsFilter = action.payload;
    },
    setMailings: (state, action) => {
      state.mailings = action.payload;
    }
  }
});

export default schedulerSlice.reducer;

export const { setMailingsFilter, setMailings } = schedulerSlice.actions;
